import { type ChainflipAsset } from '@chainflip/utils/chainflip';
import BigNumber from 'bignumber.js';

import { gql } from '@/shared/graphql/generated/cache';

export const getCachePoolsQuery = gql(/* GraphQL */ `
  query GetCachePools($baseAsset: ChainflipAsset) {
    pools: allPools(condition: { baseAsset: $baseAsset }) {
      nodes {
        baseAsset
        quoteAsset
        buyPrice
        rangeOrderPrice
        baseLiquidityAmount
        quoteLiquidityAmount
        liquidityFeeHundredthPips
      }
    }
  }
`);

export const getCachePoolsWithOrdersQuery = gql(/* GraphQL */ `
  query GetCachePoolsWithOrder($baseAsset: ChainflipAsset) {
    pools: allPools(condition: { baseAsset: $baseAsset }) {
      nodes {
        baseAsset
        quoteAsset
        buyPrice
        rangeOrderPrice
        baseLiquidityAmount
        quoteLiquidityAmount
        liquidityFeeHundredthPips
        openOrders
      }
    }
  }
`);

export const useMockChpLiquidityQuery = ({
  asset,
  accountIdSs58,
}: {
  asset: ChainflipAsset;
  accountIdSs58?: string;
}) => {
  const totalAmount = new BigNumber('1200000000000'); // total liquidity in the pool
  const totalAmountUsd = 138000;

  const totalAmountInUse = new BigNumber('120000'); // lent liquidity by all users
  const totalAmountInUseUsd = 123000;

  const userAmount = new BigNumber('1230000000'); // total user's liquidity
  const userAmountUsd = 12345.136;

  const userAmountInUse = new BigNumber('12300'); // lent liquidity by user
  const userAmountInUseUsd = 1200.1;

  const userEarnedFees = new BigNumber('10'); // earned fees by user

  return {
    data: {
      totalAmount,
      totalAmountUsd,
      totalAmountInUse,
      totalAmountInUseUsd,
      userAmount,
      userAmountUsd,
      userAmountInUse,
      userAmountInUseUsd,
      userEarnedFees,
      accountIdSs58,
      asset,
    },
    isLoading: false,
  };
};
